<kendo-excelexport [data]="filteredGridData" fileName="excelexport">
    <kendo-excelexport-column *ngFor="let col of selectedColumns" [title]="col">
    </kendo-excelexport-column>
</kendo-excelexport>